/**
 * The value for `aria-describedby`: the ids of what describes a control, in
 * the order it is read — a field's hint before its error — or nothing at all.
 */
export const describedBy = (...ids: (string | false | undefined)[]) =>
  ids.filter(Boolean).join(" ") || undefined
